export default "__VITE_ASSET__BuRqQXB6__"